import React, {useEffect, useState} from 'react';
import {Field, Form} from "react-final-form";
import {useHistory, useParams} from "react-router";
import CogoToast from "cogo-toast";
import EnigooButton from "../../../MyComponent/EnigooButton";
import {FaFileImport, FiInfo, FiSave} from "react-icons/all";
import Widget from "../../../components/widget";
import {EnigooLoader} from "../../../MyComponent/EnigooLoader";
import {apiCreateCustomField, apiGetCustomFieldById, apiUpdateCustomField} from "./Actions";
import {IconTabs} from "../../../components/tabs";
import {EnigooTextField} from "../../../MyComponent/EnigooTextField";
import {CustomFieldTypeSelectField} from "../../../MyComponent/Api/Admin/CustomFieldTypeSelectField";
import {FieldArray} from "react-final-form-arrays";
import arrayMutators, {push} from "final-form-arrays";
import {FiHelpCircle, FiPlus} from "react-icons/fi";
import EnigooBreadcrumbs from "../../../MyComponent/EnigooBreadcrumbs";
import VerifyRights from "../../VerifyRights";
import EnigooMultiLanguageField from "../../../MyComponent/EnigooMultiLanguageField/EnigooMultiLanguageField";
import {Trans, useTranslation} from "react-i18next";
import EnigooFormChangedAlert from "../../../MyComponent/EnigooFormChangedAlert";
import EnigooToolTip from "../../../MyComponent/EnigooToolTip";
import FileReaderInput from 'react-file-reader-input';
import Papa from "papaparse";

const CustomFieldForm = () => {
    let [data, setData] = useState(null);
    let [loading, setLoading] = useState(false);
    let [saving, setSaving] = useState(false);
    let [showOptions, setShowOptions] = useState(false);
    let submit;
    const history = useHistory();
    const {t} = useTranslation()
    const {id} = useParams();

    useEffect(() => {
        init();
    }, []);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if ((event.ctrlKey || event.metaKey) && event.key === 's') {
                event.preventDefault();
                submit();
                console.log('Ctrl/Command + S was pressed');
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    const init = () => {
        if (id) {
            setLoading(true);
            apiGetCustomFieldById(id, (data) => {
                data.customFieldType = data.customFieldType.id;
                data.label.language = "cs";
                setShowOptions(data.customFieldType === 3 || data.customFieldType === 4);
                setData(data);
                setLoading(false);
            }, (error) => {
                setSaving(false);
                CogoToast.error(t("userFields.loadingDataError"))
            })
        }
    }

    const onSubmitSuccess = (data, values) => {
        setData(values)
        CogoToast.success(t("userFields.saveSuccess"));
        setSaving(false);
        history.push("/custom-field/detail/" + data.id);
    }
    const onSubmitError = (error) => {
        CogoToast.error(t("userFields.saveError"));
        setSaving(false);
    }
    const onSubmit = (values) => {
        if (!showOptions && values.options) {
            values.options = null;
        }
        setSaving(true);
        if (id) {
            apiUpdateCustomField(id, values, (data) => onSubmitSuccess(data, values), onSubmitError)
        } else {
            apiCreateCustomField(values, (data) => onSubmitSuccess(data, values), onSubmitError)
        }
    }

    const onTypeChange = (event) => {
        setShowOptions(event.value === 3 || event.value === 4);
    }

    const getPreviewForTooltip = (values) => {
        if (!values.tooltip) {
            return null;
        } else {
            let previews = [];
            if (values.tooltip.cs) {
                previews.push(<div className={"flex flex-row space-x-2"}>
                    <span>CS: </span>
                    <FiHelpCircle data-tip data-for={"_tooltip_custom_field_tool_tip_preview_cs"}
                                  key={"custom_field_tool_tip_preview_cs"}
                                  className={"ml-2 text-red-900"} size={18}/>
                    <EnigooToolTip content={values.tooltip.cs} id={"_tooltip_custom_field_tool_tip_preview_cs"}
                                   place={"right"}/>
                </div>)
            }
            if (values.tooltip.sk) {
                previews.push(<div className={"flex flex-row space-x-2"}>
                    <span>SK: </span>
                    <FiHelpCircle data-tip data-for={"_tooltip_custom_field_tool_tip_preview_sk"}
                                  key={"custom_field_tool_tip_preview_sk"}
                                  className={"ml-2 text-red-900"} size={18}/>
                    <EnigooToolTip content={values.tooltip.sk} id={"_tooltip_custom_field_tool_tip_preview_sk"}
                                   place={"right"}/>
                </div>)
            }
            if (values.tooltip.en) {
                previews.push(<div className={"flex flex-row space-x-2"}>
                    <span>EN: </span>
                    <FiHelpCircle data-tip data-for={"_tooltip_custom_field_tool_tip_preview_en"}
                                  key={"custom_field_tool_tip_preview_en"}
                                  className={"ml-2 text-red-900"} size={18}/>
                    <EnigooToolTip content={values.tooltip.en} id={"_tooltip_custom_field_tool_tip_preview_en"}
                                   place={"right"}/>
                </div>)
            }
            if (values.tooltip.de) {
                previews.push(<div className={"flex flex-row space-x-2"}>
                    <span>DE: </span>
                    <FiHelpCircle data-tip data-for={"_tooltip_custom_field_tool_tip_preview_de"}
                                  key={"custom_field_tool_tip_preview_de"}
                                  className={"ml-2 text-red-900"} size={18}/>
                    <EnigooToolTip content={values.tooltip.de} id={"_tooltip_custom_field_tool_tip_preview_de"}
                                   place={"right"}/>
                </div>)
            }

            if (previews.length === 0) {
                return null;
            } else {
                return <div className={"flex flex-col space-y-1 mb-2"}>
                    <span className={"font-bold"}>Náhled zobrazované nápovědy: </span>
                    <div className={"flex flex-row space-x-2"}>{previews}
                    </div>
                </div>
            }
        }

    }

    const importOptions = (e,results,push,values)=>{
        // results je pole dvojic [event, file]
        results.forEach(([e, file]) => {
            const csvText = e.target.result;

            // Parsování CSV pomocí PapaParse
            const parsed = Papa.parse(csvText, {
                header: false,
                skipEmptyLines: true,
            });

            console.log("Nahraný soubor:", file.name);
            console.log("Data:", parsed.data);
            console.log("Chyby:", parsed.errors);

            parsed.data.forEach(row => {
                let exist = values?.options?.find(option => option.value === row[0]);
                if(row[0] !== '' && !exist){
                    const option = {
                        value: row[0]
                    }
                    push("options", option);
                }
            })

            // Můžeš uložit data do stavu nebo poslat na server
            // setOptions(parsed.data);
        })
    }

    const TabBasicsInfo = (props) => (
        <div className={"w-full flex flex-col"}>
            <EnigooTextField label={t("basics.name") + ": *"} name={"name"} placeHolder={t("placeHolder.name")}
                             outsideClassName={"w-full"} key={"0"}/>
            <EnigooMultiLanguageField label={t("basics.label") + ": *"} name={"label"}
                                      placeHolder={t("placeHolder.label")}
                                      outsideClassName={"w-full"} key={"1"}
                                      toolTip={t("placeHolder.multiLangToolTip")}/>
            <CustomFieldTypeSelectField disabled={!!id} onValueChange={onTypeChange} label={t("basics.type") + ": *"}
                                        name={"customFieldType"}
                                        outsideClassName={"w-full"} isMulti={false} key={"3"}/>
            <EnigooMultiLanguageField label={t("userFields.helpLabel")} name={"tooltip"} type={"html"}
                                      outsideClassName={"w-full"} key={"1"}
                                      toolTip={t("userFields.helpTooltip")}/>
            {getPreviewForTooltip(props.values)}
            {showOptions &&
                <>

                    <div className={"form-label"}>{t("basics.options")}:</div>
                    <div className={"flex flex-row space-x-2 w-3/4"}>
                        <EnigooButton onClick={() => props.push("options", undefined)}
                                                               text={t("basics.add")} icon={<FiPlus size={10}/>}/>
                        <FileReaderInput id={"import_options"} as={"text"} accept={".csv"} onChange={(e,results)=>importOptions(e,results,props.push,props.values)}>
                            <EnigooButton onClick={() => {}} toolTip={t("userFields.importOptionsToolTip")}
                                          text={t("basics.import")} icon={<FaFileImport size={10}/>}/>
                        </FileReaderInput>

                    </div>

                    <div className={"form-element"}>
                        <div className={"grid grid-cols-1 lg:grid-cols-3 gap-2"}>
                        <FieldArray name={"options"}>
                            {({fields}) =>
                                fields.map((name, index) => (
                                    <div key={name} className={"w-full"}>
                                        <div className={'flex flex-row mt-2'}>
                                            <div className={"form-label pt-3 mr-3 w-1/12"}>#{index + 1}</div>
                                            <div className={"form-input flex-1"}>
                                                <Field
                                                    name={`${name}.value`}
                                                    component={"input"}
                                                    placeholder={t("placeHolder.option")}
                                                />
                                            </div>
                                            <Field
                                                name={`${name}.id`}
                                                defaultValue={index + 1}
                                            >
                                                {props => (
                                                    <input {...props.input} hidden={true}/>
                                                )}
                                            </Field>

                                            <div
                                                className={"ml-2 pt-3"}
                                                onClick={() => fields.remove(index)}
                                                style={{cursor: "pointer"}}>❌
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </FieldArray>
                        </div>
                    </div>
                </>}
        </div>
    );

    return (
        <Form onSubmit={onSubmit} initialValues={data}
              validate={values => {
                  let errors = {};
                  if (!values.name) {
                      errors.name = t("basics.requireField");
                  }
                  if (!values.label || !values.label.cs) {
                      errors.label = {cs: t("basics.requireField")};
                  }
                  if (!values.customFieldType) {
                      errors.customFieldType = t("basics.requireField");
                  }
                  return errors;
              }
              }
              mutators={{...arrayMutators}}
              render={({
                           handleSubmit,
                           form, values,
                           dirty,
                           form: {
                               mutators: {push, pop, unshift}
                           },
                       }) => {
                  submit = handleSubmit;
                  return (
                      <>
                          <EnigooBreadcrumbs
                              right={<VerifyRights page={"customField"}
                                                   action={id ? "updateCustomField" : "createCustomField"}>
                                  <EnigooButton onClick={() => submit()} icon={<FiSave/>} text={t("basics.save")}
                                                loading={saving} disabled={saving || loading}/></VerifyRights>}/>
                          <EnigooFormChangedAlert onReset={() => form.reset(data)} onSave={handleSubmit}
                                                  dirty={dirty}/>
                          <Widget>
                              {loading ? <EnigooLoader text={t("userFields.loadingData")}/> :
                                  <div className={"flex flex-col"}>

                                      <IconTabs tabs={[
                                          {
                                              index: 0,
                                              content: <TabBasicsInfo push={push} values={values}/>,
                                              title: (<><FiInfo size={18} className={"stroke-current"}/><span
                                                  className={"ml-2"}><Trans
                                                  i18nKey={"basics.info"}>Zakladni info</Trans></span> </>)
                                          }
                                      ]}/>

                                  </div>}
                          </Widget>
                      </>
                  );
              }
              }/>
    )
}
export default CustomFieldForm;



